import React from 'react';
import ServicesIcon from './ServicesIcons';
import PropTypes from 'prop-types';
import {Box} from '@mui/material';

const ServicesIconsGroup = ({stepsData = []}) => {

    const seen = new Set();
    const filteredExecuted = stepsData.filter(service => {
        const name = service.service_name?.toLowerCase();
        if (!name || seen.has(name)) return false;
        seen.add(name);
        return name;
    });

    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {filteredExecuted.map(service => (
          <ServicesIcon
            key={service.service_name}
            serviceName={service.service_name}
            status={service.service_status}
            slug={service.service_slug}
          />
        ))}
      </Box>
    );
};
ServicesIconsGroup.propTypes = {
    stepsData: PropTypes.arrayOf(
        PropTypes.shape({
            service_name: PropTypes.string.isRequired,
            service_status: PropTypes.string.isRequired,
        })
    ),
};

export default ServicesIconsGroup;
